<template>
    <emc-card-stats 
        color="blue lighten-1"
        icon="mdi-school-outline"
        icon-large
        :title="this.title"
        :value="this.teachers"
        sub-text="Número de professores ativos"
        >
        <template v-slot:tools>
            <emc-chart-refresh-status :label="statusLabel" :failed="hasFailed" :error-code="errorCode" />
        </template>
        <template v-slot:actions>
            <emc-button-icon btn-small :disabled="isBusy" icon="mdi-refresh-circle" :text="updated_at || `Atualizar`" color="success" @click.prevent.stop="start()" />
        </template>
    </emc-card-stats>
</template>

<script>

import { getCurrentInstance } from 'vue'
import { mapActions } from 'vuex'
import { useChartRefresh } from '@/composables/useChartRefresh'

export default {
    name: 'EmcChartTeacherNumber',
    setup() {
        const { proxy } = getCurrentInstance()

        return useChartRefresh({
            refreshAction: 'chart/ActionTeacherNumbersRefresh',
            onFinished: () => proxy.getData()
        })
    },
    data () {
        return {
            teachers: '0',
            title: '',
            updated_at: null
        }
    },
    methods: {
        ...mapActions('chart', ['ActionChartTeacherNumber']),
        async getData() {
            await this.ActionChartTeacherNumber()
                .then((r) => {
                    this.teachers = r.data.value.toString()
                    this.title = r.data.title
                    this.updated_at = r.data.updated_at

                    // Recarga já em andamento (normalmente a carga noturna):
                    // o card mostra o andamento sem o usuário ter clicado.
                    this.adopt(r.data.refresh)
                })
        }
    },
    created(){
        this.getData()
    }

    
}
</script>